var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',[_c('authenticator',{staticClass:"auth"})],1):_c('div',{staticClass:"mt-6 loading"},[_c('v-progress-linear',{attrs:{"indeterminate":"","color":"#fa712a"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }